import React from "react";
import ReactDOM from "react-dom/client"; // Импортируем createRoot вместо render
import App from "./App";
import { ThemeProvider, createTheme } from "@mui/material/styles";

// Создание темы
const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#ff4081",
    },
  },
  typography: {
    fontFamily: "Arial",
  },
});

// Найдём корневой элемент
const rootElement = document.getElementById("root");

// Создадим корневой рендерер
const root = ReactDOM.createRoot(rootElement);

// Рендерим компонент App внутри ThemeProvider
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
